import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { FilteredSelectComponent } from './filtered-select.component';
import { FilteredSelectOptionDirective } from './filtered-select-option.directive';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  exports: [FilteredSelectComponent, FilteredSelectOptionDirective],
  declarations: [FilteredSelectComponent, FilteredSelectOptionDirective]
})
export class FilteredSelectModule {}
